import {createMuiTheme} from '@material-ui/core/styles';

export const primaryColor = '#181F28';
export const primarySelectedColor = 'rgb(0, 150, 136, 0.15)';
export const primaryHoverColor = 'rgb(0, 150, 136, 0.1)';
export const primaryPostHoverColor = 'rgb(0, 150, 136, 0.05)';
export const errorColor = '#f45858';
export const errorHoverColor = '#c24949';
export const errorContrastText = '#323232';

export default createMuiTheme({
  typography: {
    h4: {
      fontFamily: ['GolosTextWebMedium', 'Roboto'],
      fontSize: 29,
      lineHeight: '32pt',
    },
    h5: {
      fontFamily: ['GolosTextWebMedium', 'Roboto'],
      fontSize: 24,
      lineHeight: '28pt',
    },
    h6: {
      fontFamily: ['GolosTextWebMedium', 'Roboto'],
      fontSize: 20,
      lineHeight: '24pt',
    },
    subtitle1: {
      fontSize: 16,
      lineHeight: '16pt',
    },
    subtitle2: {
      fontFamily: ['GolosTextWebMedium', 'Roboto'],
      fontSize: 14,
      lineHeight: '14pt',
    },
    body1: {
      fontSize: 14,
      lineHeight: '1.4',
    },
    caption: {
      color: '#AAAAAA',
      fontSize: 12,
      lineHeight: '14pt',
    },
    button: {
      textTransform: 'none',
    },
    useNextVariants: true,
    fontFamily: [
      'GolosTextWebRegular',
      'Roboto',
    ],
  },
  palette: {
    primary: {
      main: primaryColor,
      contrastText: '#fff',
    },
    secondary: {
      main: '#c0c0c0',
      contrastText: '#323232',
    },
    grey: {
      main: '#898989',
    },
    buttonGrey: {
      main: '#c5c5c5',
      hover: '#bbbbbb',
      contrastText: '#323232',
    },
    error: {
      main: errorColor,
      hover: errorHoverColor,
      contrastText: '#323232',
    },
  },
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(20, 20, 30, 0.80)',
      },
    },
    MuiButton: {
      root: {
        fontFamily: ['GolosTextWebMedium', 'Roboto'],
        '&$disabled': {
          opacity: 1,
        },
        // Responsive размеры для мобильных устройств (fontSize и padding)
        // height оставляем для локальных стилей компонентов
        '@media (max-width:599px)': {
          fontSize: 14,
          padding: '12px 16px',
        },
        '@media (min-width:600px) and (max-width:959px)': {
          fontSize: 15,
          padding: '14px 18px',
        },
      },
      disabled: {}, // ← обязательно объявить пустой класс!
    },
    MuiIconButton: {
      root: {
        // Responsive размеры для мобильных устройств
        '@media (max-width:599px)': {
          padding: 8,
        },
        '@media (min-width:600px) and (max-width:959px)': {
          padding: 10,
        },
      },
    },
    MuiInput: {
      underline: {
        '&:hover:not($disabled):not($focused):not($error):before': {borderBottomColor: primaryColor},
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 12,
        maxWidth: 360,
        padding: '16px 15px 17px 24px',
      },
    },
    MuiMenuItem: {
      root: {
        '&$selected': {
          backgroundColor: primarySelectedColor,
          fontWeight: 500,
          '&:focus': {
            backgroundColor: primarySelectedColor,
          },
          '&:hover': {
            backgroundColor: primaryHoverColor,
          },
        },
        '&:hover': {
          backgroundColor: primaryHoverColor,
        },
        '&:focus': {
          backgroundColor: primaryPostHoverColor,
        },
      },
    },
    MuiListItem: {
      button: {
        '&:hover': {
          backgroundColor: primaryHoverColor,
        },
        '&:focus': {
          backgroundColor: primaryPostHoverColor,
        },
      },
      root: {
        // Responsive размеры для мобильных устройств
        '@media (max-width:599px)': {
          minHeight: 40,
          padding: '10px 12px',
          '& .MuiListItemText-root > .MuiTypography-body1': {
            fontSize: 14,
            lineHeight: '18px',
          },
        },
        '@media (min-width:600px) and (max-width:959px)': {
          minHeight: 42,
          padding: '11px 12px',
          '& .MuiListItemText-root > .MuiTypography-body1': {
            fontSize: 15,
            lineHeight: '19px',
          },
        },
        '&$disabled': {
          opacity: 1,
          "& .MuiListItemText-root > .MuiTypography-body1": {
            color: "rgba(37,53,79,0.38)",
          },
          "& .MuiListItemIcon-root > svg": {
            color: "rgba(37,53,79,0.38)",
          }
        },
      },
      disabled: {}, // ← обязательно
    },

    MuiTouchRipple: {
      rippleVisible: {
        color: 'rgb(0, 150, 136, 0.25) !important',
      },
    },

    MuiTableCell: {
      root: {
        padding: 12,
      },
      head: {
        color: '#AAAAAA',
        fontSize: 12,
        lineHeight: '14pt',
        backgroundColor: '#f7f8fb',
      },
    },
  },
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px)': {
        '@media (orientation: landscape)': {
          minHeight: 48,
        }
      },
      '@media (min-width:600px)': {
        minHeight: 60
      }
    }
  }
});
